import {TabLimpiezaModel} from '../../../models'
import {ShowSnackBar, confirmModal} from '../../../util/functions'
import {SUCCESS_MESSAGE_DELETE, ERROR_MESSAGE_SYSTEM} from '../../../util/Constants'
export const funcDelete = async (
  service: (id: string) => Promise<any>,
  currentTabItem: TabLimpiezaModel,
  setLoading: (loading: boolean) => void,
  changeCurrentTabItem: any,
  id: string,
) => {
  let title = '¿Estás seguro?'
  let bodyText = 'Al eliminar no podrás revertir esta acción'
  let textButtonCancel = 'No'
  let textButtonConfirm = 'Si, eliminar'
  try {
    const result = await confirmModal({
      title,
      bodyText,
      icon: 'warning',
      textButtonCancel,
      textButtonConfirm,
    })
    if (!result.isConfirmed) return
    setLoading(true)
    const response = await service(id)
    if (!response.data.error) {
      const updatedTabItem: TabLimpiezaModel = {
        ...currentTabItem,
        idToDelete: '',
        loadingTable: true,
      }
      changeCurrentTabItem(updatedTabItem)
      ShowSnackBar(SUCCESS_MESSAGE_DELETE)
    } else {
      ShowSnackBar(response.data.messageSystem, 'error')
    }
  } catch (error) {
    console.error('Error al eliminar:', error)
    ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
  } finally {
    setLoading(false)
  }
}
